import axios from 'axios'
import authHeader from '../../module/auth-header'

export const chatService = {
  load,
  send,
  receive,
  delete: _delete
}

function send(username, password) {
  return axios.get(
    process.env.REACT_APP_DEV_LOGIN_LOCAL_API_URL + '/message'
  )
}

function receive() {
  return axios.get(
    process.env.REACT_APP_DEV_LOGIN_LOCAL_API_URL + '/message'
  )
}

function load() {
  return axios.get(
    process.env.REACT_APP_DEV_LOGIN_LOCAL_API_URL + '/message'
  )
}

function _delete(id) {
  // const requestOptions = {
  //     method: 'DELETE',
  //     headers: authHeader()
  // }
  //
  // return fetch(`/users/${id}`, requestOptions).then(handleResponse)
}
